/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as SessionRouteRouteImport } from './routes/session/route'
import { Route as InvitationsRouteRouteImport } from './routes/invitations/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SessionIndexRouteImport } from './routes/session/index'
import { Route as InvitationsIndexRouteImport } from './routes/invitations/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TokenCallbackRouteImport } from './routes/token/callback'
import { Route as SessionNewRouteImport } from './routes/session/new'
import { Route as SessionCallbackRouteImport } from './routes/session/callback'
import { Route as AdminTokensIndexRouteImport } from './routes/admin/tokens/index'
import { Route as AdminLogoutIndexRouteImport } from './routes/admin/logout/index'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionRouteRoute = SessionRouteRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsRouteRoute = InvitationsRouteRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionIndexRoute = SessionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionRouteRoute,
} as any)
const InvitationsIndexRoute = InvitationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvitationsRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TokenCallbackRoute = TokenCallbackRouteImport.update({
  id: '/token/callback',
  path: '/token/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionNewRoute = SessionNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SessionRouteRoute,
} as any)
const SessionCallbackRoute = SessionCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => SessionRouteRoute,
} as any)
const AdminTokensIndexRoute = AdminTokensIndexRouteImport.update({
  id: '/tokens/',
  path: '/tokens/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLogoutIndexRoute = AdminLogoutIndexRouteImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/invitations': typeof InvitationsRouteRouteWithChildren
  '/session': typeof SessionRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/session/callback': typeof SessionCallbackRoute
  '/session/new': typeof SessionNewRoute
  '/token/callback': typeof TokenCallbackRoute
  '/admin/': typeof AdminIndexRoute
  '/invitations/': typeof InvitationsIndexRoute
  '/session/': typeof SessionIndexRoute
  '/admin/logout': typeof AdminLogoutIndexRoute
  '/admin/tokens': typeof AdminTokensIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/session/callback': typeof SessionCallbackRoute
  '/session/new': typeof SessionNewRoute
  '/token/callback': typeof TokenCallbackRoute
  '/admin': typeof AdminIndexRoute
  '/invitations': typeof InvitationsIndexRoute
  '/session': typeof SessionIndexRoute
  '/admin/logout': typeof AdminLogoutIndexRoute
  '/admin/tokens': typeof AdminTokensIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/invitations': typeof InvitationsRouteRouteWithChildren
  '/session': typeof SessionRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/session/callback': typeof SessionCallbackRoute
  '/session/new': typeof SessionNewRoute
  '/token/callback': typeof TokenCallbackRoute
  '/admin/': typeof AdminIndexRoute
  '/invitations/': typeof InvitationsIndexRoute
  '/session/': typeof SessionIndexRoute
  '/admin/logout/': typeof AdminLogoutIndexRoute
  '/admin/tokens/': typeof AdminTokensIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/invitations'
    | '/session'
    | '/$'
    | '/session/callback'
    | '/session/new'
    | '/token/callback'
    | '/admin/'
    | '/invitations/'
    | '/session/'
    | '/admin/logout'
    | '/admin/tokens'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/session/callback'
    | '/session/new'
    | '/token/callback'
    | '/admin'
    | '/invitations'
    | '/session'
    | '/admin/logout'
    | '/admin/tokens'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/invitations'
    | '/session'
    | '/$'
    | '/session/callback'
    | '/session/new'
    | '/token/callback'
    | '/admin/'
    | '/invitations/'
    | '/session/'
    | '/admin/logout/'
    | '/admin/tokens/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  InvitationsRouteRoute: typeof InvitationsRouteRouteWithChildren
  SessionRouteRoute: typeof SessionRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  TokenCallbackRoute: typeof TokenCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session': {
      id: '/session'
      path: '/session'
      fullPath: '/session'
      preLoaderRoute: typeof SessionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations': {
      id: '/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof InvitationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session/': {
      id: '/session/'
      path: '/'
      fullPath: '/session/'
      preLoaderRoute: typeof SessionIndexRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/invitations/': {
      id: '/invitations/'
      path: '/'
      fullPath: '/invitations/'
      preLoaderRoute: typeof InvitationsIndexRouteImport
      parentRoute: typeof InvitationsRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/token/callback': {
      id: '/token/callback'
      path: '/token/callback'
      fullPath: '/token/callback'
      preLoaderRoute: typeof TokenCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session/new': {
      id: '/session/new'
      path: '/new'
      fullPath: '/session/new'
      preLoaderRoute: typeof SessionNewRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/session/callback': {
      id: '/session/callback'
      path: '/callback'
      fullPath: '/session/callback'
      preLoaderRoute: typeof SessionCallbackRouteImport
      parentRoute: typeof SessionRouteRoute
    }
    '/admin/tokens/': {
      id: '/admin/tokens/'
      path: '/tokens'
      fullPath: '/admin/tokens'
      preLoaderRoute: typeof AdminTokensIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/logout/': {
      id: '/admin/logout/'
      path: '/logout'
      fullPath: '/admin/logout'
      preLoaderRoute: typeof AdminLogoutIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminLogoutIndexRoute: typeof AdminLogoutIndexRoute
  AdminTokensIndexRoute: typeof AdminTokensIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminLogoutIndexRoute: AdminLogoutIndexRoute,
  AdminTokensIndexRoute: AdminTokensIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface InvitationsRouteRouteChildren {
  InvitationsIndexRoute: typeof InvitationsIndexRoute
}

const InvitationsRouteRouteChildren: InvitationsRouteRouteChildren = {
  InvitationsIndexRoute: InvitationsIndexRoute,
}

const InvitationsRouteRouteWithChildren =
  InvitationsRouteRoute._addFileChildren(InvitationsRouteRouteChildren)

interface SessionRouteRouteChildren {
  SessionCallbackRoute: typeof SessionCallbackRoute
  SessionNewRoute: typeof SessionNewRoute
  SessionIndexRoute: typeof SessionIndexRoute
}

const SessionRouteRouteChildren: SessionRouteRouteChildren = {
  SessionCallbackRoute: SessionCallbackRoute,
  SessionNewRoute: SessionNewRoute,
  SessionIndexRoute: SessionIndexRoute,
}

const SessionRouteRouteWithChildren = SessionRouteRoute._addFileChildren(
  SessionRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  InvitationsRouteRoute: InvitationsRouteRouteWithChildren,
  SessionRouteRoute: SessionRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  TokenCallbackRoute: TokenCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
